import { EModalName } from '@/helpers/modal';
import { Component } from 'vue-property-decorator';
import EditorBase from '../EditorBase';
import ConfirmationModal from '@/components/modals/ConfirmationModal.vue';

@Component({
  components: {
    ConfirmationModal
  }
})
export default class Layer extends EditorBase {
  get modalName(): string {
    return EModalName.themeResetConfirmation;
  }

  hideModal() {
    this.$modal.hide(this.modalName);
  }

  get modalTitle(): string {
    return `Unlink the ${this.appliedThemeName} Overlay?`;
  }

  get modalText(): string {
    return 'Are you sure you want to unlink this overlay? This action cannot be undone, but you can change overlay anytime from the library.';
  }
}
